import React from "react";
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const WidgetOptions =
    ({
         className = "",
         loading = false,
         showRefreshIcon = false,
         showDeleteIcon = true,
         showEditIcon = true,
         showDuplicateIcon = true,
         isEditMode = false,
         widgetHasError = false,
         isDashboardFullScreen = false,
         onRefreshClicked = () => { },
         onEditClicked = () => { },
         onDuplicateClicked = () => { },
         onDeleteClicked = () => { }
     }) => {
        return <div className={className}>
            {renderAlertIcon(widgetHasError)}
            {renderDuplicateIcon(showDuplicateIcon, isEditMode, isDashboardFullScreen, widgetHasError, onDuplicateClicked)}
            {renderRefreshIcon(loading, showRefreshIcon, widgetHasError, onRefreshClicked)}
            {renderEditIcon(isEditMode, showEditIcon, isDashboardFullScreen, onEditClicked)}
            {renderDeleteIcon(isEditMode, showDeleteIcon, isDashboardFullScreen, onDeleteClicked)}
        </div>;
    };

function renderRefreshIcon(loading, showRefreshIcon, widgetHasError, onRefreshClicked) {
    if (showRefreshIcon && !widgetHasError) {
        return (
            <FontAwesomeIcon icon={['fas', 'sync']} className="cursor-pointer widget-option" spin={loading} onClick={onRefreshClicked}/>
        )
    }
}

function renderDeleteIcon(isEditMode, showDeleteIcon, isDashboardFullScreen, onDeleteClicked) {
    if(showDeleteIcon && isEditMode && !isDashboardFullScreen) {
        return (
            <FontAwesomeIcon icon={['fas', 'trash']} className="cursor-pointer widget-option" onClick={onDeleteClicked}/>
        );
    }
}

function renderEditIcon(isEditMode, showEditIcon, isDashboardFullScreen, onEditClicked) {
    if(showEditIcon && isEditMode && !isDashboardFullScreen) {
        return (
            <FontAwesomeIcon icon={['fas', 'pen']} className="cursor-pointer widget-option" onClick={onEditClicked}/>
        );
    }
}

function renderDuplicateIcon(showDuplicateIcon, isEditMode, isDashboardFullScreen, widgetHasError, onDuplicateClicked) {
    if(showDuplicateIcon && isEditMode && !widgetHasError && !isDashboardFullScreen) {
        return (
            <FontAwesomeIcon icon={['far', 'clone']} className="cursor-pointer widget-option" onClick={onDuplicateClicked}/>
        );
    }
}

function renderAlertIcon(widgetHasError) {
    if(widgetHasError) {
        return (
            <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} className="cursor-pointer widget-option" size="lg"/>
        );
    }
}

WidgetOptions.propTypes = {
    isPreview: PropTypes.bool,
    showRefreshIcon: PropTypes.bool,
    showDeleteIcon: PropTypes.bool,
    showEditIcon: PropTypes.bool,
    showDuplicateIcon: PropTypes.bool,
    isEditMode: PropTypes.bool,
    onRefreshClicked: PropTypes.func,
    onEditClicked: PropTypes.func.isRequired,
    onDeleteClicked: PropTypes.func.isRequired,
    onDuplicateClicked: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
    widgetHasError: PropTypes.bool,
};

export default WidgetOptions;